export const getSlugFromUrl = (): string | null => {
  const hostname = window.location.hostname;
  const excludedHosts = [
    "granatech.com.br",
    "www.granatech.com.br",
    "localhost",
    "admin"
  ];

  if (excludedHosts.includes(hostname)) {
    return null;
  }

  return hostname.split(".")[0];
};
